export const GetTradeInitial = ({
  coinId,
  sideId,
  walletTypeId,
  coinMasterId,
}) =>
  `/Trade/GetTradeInitial?CoinId=${coinId}&CoinMasterId=${coinMasterId}&SideId=${sideId}&WalletTypeId=${walletTypeId}`;

export const GetTradeAmountMax = ({
  coinId,
  coinMasterId,
  sideId,
  walletTypeId,
}) =>
  `/Trade/GetTradeAmountMax?CoinId=${coinId}&CoinMasterId=${coinMasterId}&SideId=${sideId}&WalletTypeId=${walletTypeId}`;

export const TradeInsertInitial = "/Trade/TradeInsertInitial";

export const TradeInsertConfirmedUser = "/Trade/TradeInsertConfirmedUser";
